<div class="grid transition-[grid-template-rows] ease-in-out" [class]="classes()">
	<div class="overflow-hidden">
		<ng-content></ng-content>
	</div>
</div>
